import { Inject, Injectable } from '@angular/core';
import { AppParameterHandler } from '../../model/app-parameter-handler.model';
import { Params } from '@angular/router';
import { CONSTANTS } from 'src/app/config/constants.module';
import { MessageService } from 'src/app/core/service/message.service';
import { ZoomToAreaParameters } from './model/zoom-to-area-params.model';
import { MainMapService } from 'src/app/shared/service/main-map.service';
import {Arbeitsbereich} from "../../../../../config/model/arbeitsbereich-config.model";
import {EsriExtent, EsriGraphic, EsriReactiveUtils} from "../../../../../config/esri.module";
import {SelectionService} from "../../../../../shared/service/selection.service";
import {ArbeitsbereichService} from "../../../../../shared/service/arbeitsbereich.service";
import {
  WorkspaceNotifyService
} from "../../../../../component/header-panel/arbeitsbereich/workspace-notify.service";

@Injectable({
  providedIn: 'root',
})
export class ZoomToAreaService implements AppParameterHandler {
  name: string;

  constructor(
    private messageService: MessageService,
     private mainMapService: MainMapService,
    private selectionService: SelectionService,
    private arbeitsbereichService: ArbeitsbereichService,
    private workspaceNotifyService: WorkspaceNotifyService,
    @Inject(CONSTANTS) private CONST: any
  ) {
    this.name = this.CONST.APP_URL_PARAMS.FUNCTIONS.ZOOM_TO_WINDOW_AREA;
  }

  /**
   * zooms to a specific area on the map
   * @param params the parameters to zoom to
   */
  parameterFunction(params: Params) {
    const p: ZoomToAreaParameters = this.zoomToAreaParams(params);
    if (this.isInSwitzerland(p) && this.coordinatesAreSet(p)) {
      this.messageService.success('NOTIFICATIONS.SUCCESS.ZOOM_TO_WINDOW_PARAMETERS_SUCCESS');
      this.zoomToArea(p.easting1, p.northing1, p.easting2, p.northing2, p.workspace);
    }
  }

  /**
   * converts the params to ZoomToPointParams & returns it
   * @param params the params to convert
   */
  private zoomToAreaParams(params: Params): ZoomToAreaParameters {
    const p = new ZoomToAreaParameters();
    p.easting1 = parseInt(params[this.CONST.APP_URL_PARAMS.PARAMETER_NAMES.EASTING1]);
    p.northing1 = parseInt(params[this.CONST.APP_URL_PARAMS.PARAMETER_NAMES.NORTHING1]);
    p.easting2 = parseInt(params[this.CONST.APP_URL_PARAMS.PARAMETER_NAMES.EASTING2]);
    p.northing2 = parseInt(params[this.CONST.APP_URL_PARAMS.PARAMETER_NAMES.NORTHING2]);
    p.workspace = params[this.CONST.APP_URL_PARAMS.PARAMETER_NAMES.WORKSPACE];
    return p;
  }

  /**
   * Check if easting and northing is in switzerland
   * @param p the parameters to check
   */
  private isInSwitzerland(p: ZoomToAreaParameters): boolean {
    let valid = true;
    // We should check the values of the coordinates to make sure they are in Switzerland
    if (p.easting1 < 2480000 || p.easting1 > 2840000) {
      this.messageService.error('NOTIFICATIONS.ERROR.APP_PARAMETERS.EASTING1_NOT_IN_CH');
      valid = false;
    }
    if (p.easting2 < 2480000 || p.easting2 > 2840000) {
      this.messageService.error('NOTIFICATIONS.ERROR.APP_PARAMETERS.EASGTING2_NOT_IN_CH');
      valid = false;
    }
    if (p.northing1 < 1070000 || p.northing1 > 1300000) {
      this.messageService.error('NOTIFICATIONS.ERROR.APP_PARAMETERS.NORTHING1_NOT_IN_CH');
      valid = false;
    }
    if (p.northing2 < 1070000 || p.northing2 > 1300000) {
      this.messageService.error('NOTIFICATIONS.ERROR.APP_PARAMETERS.NORTHING2_NOT_IN_CH');
      valid = false;
    }
    return valid;
  }

  /**
   * check if e & n have values
   * @param p the parameters to check
   */
  private coordinatesAreSet(p: ZoomToAreaParameters): boolean {
    // Check that all parameters have been passed that we need
    let valid = true;
    if (!p.easting1 || !p.northing1 || !p.easting2 || !p.northing2) {
      this.messageService.error(
        'NOTIFICATIONS.ERROR.APP_PARAMETERS.INVALID_ZOOM_TO_WINDOW_AREA_PARAMS'
      );
      valid = false;
    }
    return valid;
  }

  /**
   * @param eastings1
   * @param northings1
   * @param eastings2
   * @param northings2
   * @param arbeitsBereichId
   * @description Zoom in a specific area on the map
   */
  public zoomToArea(
    eastings1: number,
    northings1: number,
    eastings2: number,
    northings2: number,
    arbeitsBereichId?: string
  ) {
    try {
      /*  if (arbeitsBereichId) {
        const arbeitsBereich: Arbeitsbereich = this._arbeitsbereichService.arbeitsBereiche.filter(
          f => f.id === arbeitsBereichId
        )[0];
        this._arbeitsbereichService.setSelected(arbeitsBereich);
      }*/

      const extent: __esri.Extent = new EsriExtent({
        xmin: eastings1,
        ymin: northings1,
        xmax: eastings2,
        ymax: northings2,
        spatialReference: this.mainMapService.mapView.extent.spatialReference,
      });

      const newGrphic = new EsriGraphic({
        geometry: extent,
      });

      EsriReactiveUtils.when(
        () => this.mainMapService.mapView.ready === true,
        () => {
          this.selectionService.goToFeature(newGrphic, { animate: true }).then(() => {
            if (arbeitsBereichId) {
              const arbeitsBereich: Arbeitsbereich = this.arbeitsbereichService.arbeitsBereiche.filter(
                f => f.id === arbeitsBereichId
              )[0];
              this.arbeitsbereichService.setSelected(arbeitsBereich);
              this.workspaceNotifyService.setWorkspace(
                this.arbeitsbereichService.selectedArbeitsbereich
              );
            }
          });
        }
      );
    } catch (error) {
      throw Error(error);
    }
  }
}
